import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageLayoutProps {
	children: ReactNode;
	className?: string;
}

/**
 * Consistent page layout component that prevents scrollbar-induced layout shifts
 * by ensuring consistent height and scrollbar behavior across all pages.
 */
export function PageLayout({ children, className }: PageLayoutProps) {
	return (
		<div className={cn("min-h-screen bg-background", className)}>
			<div className="mx-auto w-full max-w-6xl space-y-8 px-4 pb-10 pt-6 sm:px-6 lg:px-8">
				{children}
			</div>
		</div>
	);
}
